'use client';

import type * as PostHog from 'posthog-js';

import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';

/** Used to immediately execute the `props.onLoad` tracking function on the client.
 * This is useful for setting server side cookies, analytics, etc., etc. */
export const TrackingAction: React.FC<{
    /** Useful for calling server actions */
    onLoad?: () => void;

    eventName?: PostHog.EventName;
    properties?: PostHog.Properties;
}> = props => {
    const posthog = usePostHog();

    useEffect(() => {
        if (props.onLoad) props.onLoad();

        if (props.eventName) {
            posthog.capture(props.eventName, props.properties || null);
        }
    }, []);

    return null;
};
